gsap.registerPlugin(ScrollTrigger);
gsap.to('.co-pr-main .z-ani-o', { opacity: 1, duration: 0.3, ease: "none" });
// GLOBAL
function coHandleStickyOnScroll(selector) {
  let lastScroll = window.scrollY;
  const el = document.querySelector(selector);
  if (!el) return;
  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;
    if (currentScroll < lastScroll) {
      el.classList.add('co-sticky');
    } else {
      el.classList.remove('co-sticky');
    }
    lastScroll = currentScroll;
  });
}
coHandleStickyOnScroll('.co-pr-main-media-frame');
coHandleStickyOnScroll('.co-pr-main-info-frame');
coHandleStickyOnScroll('.co-pr-main-navigation-frame');
// MAIN
const cP1Swiper1 = new Swiper('.co-pr-main-media-nav-slider', {
  observer: true,
  observeParents: true,
  slidesPerView: "auto",
  spaceBetween: 0,
  speed: 300,
  loop: false,
  centeredSlides: false,
  watchSlidesProgress: true,
  mousewheel: {
    forceToAxis: true,
  },
});
const cP1Swiper2 = new Swiper('.co-pr-main-media-slider', {
  observer: true,
  observeParents: true,
  slidesPerView: 1,
  speed: 300,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: true,
  // },
  loop: false,
  allowTouchMove: false,
  thumbs: {
    swiper: cP1Swiper1
  },
  navigation: {
    nextEl: '.co-pr-main-nav-arrow-next',
    prevEl: '.co-pr-main-nav-arrow-prev',
  },
});
// ACCORDION
class Accordion {
    constructor(element, options = {}) {
        this.accordion = element;
        this.options = {
            allowMultiple: element.dataset.allowMultiple === 'true' || options.allowMultiple || false,
            initialOpen: element.dataset.initialOpen || options.initialOpen || null,
            openAll: element.dataset.openAll === 'true' || options.openAll || false,
            animationDuration: options.animationDuration || 300,
            ...options
        };
        this.headers = this.accordion.querySelectorAll('[data-accordion-header]');
        this.contents = this.accordion.querySelectorAll('[data-accordion-content]');
        
        this.init();
    }
    init() {
        this.accordion.classList.add('accordion-initialized');
        this.headers.forEach((header, index) => {
            header.setAttribute('aria-expanded', 'false');
            header.setAttribute('aria-controls', `accordion-content-${index}`);
            header.id = `accordion-header-${index}`;
            const content = this.contents[index];
            content.setAttribute('aria-labelledby', `accordion-header-${index}`);
            content.id = `accordion-content-${index}`;
            content.setAttribute('role', 'region');
            header.addEventListener('click', () => this.togglePanel(index));
            header.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.togglePanel(index);
                } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    this.focusNextHeader(index);
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.focusPreviousHeader(index);
                }
            });
        });
        if (this.options.initialOpen !== null) {
            const initialIndex = parseInt(this.options.initialOpen);
            if (initialIndex >= 0 && initialIndex < this.headers.length) {
                this.openPanel(initialIndex);
            }
        }
        if (this.options.openAll) {
            this.openAllPanels();
        }
        setTimeout(() => {
            this.accordion.classList.add('accordion-initialized-after');
        }, 500);
    }
    togglePanel(index) {
        const header = this.headers[index];
        const content = this.contents[index];
        const isOpen = header.classList.contains('active');
        
        if (isOpen) {
            this.closePanel(index);
        } else {
            if (!this.options.allowMultiple) {
                this.closeAllPanels();
            }
            this.openPanel(index);
        }
    }
    openPanel(index) {
        const header = this.headers[index];
        const content = this.contents[index];
        header.classList.add('active');
        header.setAttribute('aria-expanded', 'true');
        content.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
    }
    closePanel(index) {
        const header = this.headers[index];
        const content = this.contents[index];
        
        header.classList.remove('active');
        header.setAttribute('aria-expanded', 'false');
        content.classList.remove('active');
        content.style.maxHeight = '0px';
    }
    closeAllPanels() {
        this.headers.forEach((_, index) => {
            this.closePanel(index);
        });
    }
    openAllPanels() {
        this.headers.forEach((_, index) => {
            this.openPanel(index);
        });
    }
    focusNextHeader(currentIndex) {
        const nextIndex = (currentIndex + 1) % this.headers.length;
        this.headers[nextIndex].focus();
    }
    focusPreviousHeader(currentIndex) {
        const prevIndex = currentIndex === 0 ? this.headers.length - 1 : currentIndex - 1;
        this.headers[prevIndex].focus();
    }
}
document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('[data-accordion]');
    accordions.forEach(accordion => {
        new Accordion(accordion);
    });
});
function initAccordion(selector, options = {}) {
    const element = document.querySelector(selector);
    if (element) {
        return new Accordion(element, options);
    }
}
// TABS
const thumbnails = document.querySelectorAll('.co-pr-main-navigation-thumbnail-item');
const collections = document.querySelectorAll('.co-pr-main-navigation-collection');
let activeTab = document.querySelector('.co-pr-main-navigation-thumbnail-item.co-active');
if (!activeTab && thumbnails.length > 0) {
  activeTab = thumbnails[0];
}
if (activeTab) {
  activeTab.classList.add('co-active');
  const activeCollectionId = activeTab.getAttribute('data-collection-id');
  const activeCollection = document.getElementById(activeCollectionId);
  if (activeCollection) {
    activeCollection.classList.remove('co-hidden');
    activeCollection.classList.add('co-active');
  }
}
thumbnails.forEach(function(thumbnail) {
  thumbnail.addEventListener('click', function() {
    if (thumbnail.classList.contains('co-active')) {
      return; 
    }
    thumbnails.forEach(function(th) {
      th.classList.remove('co-active');
    });
    thumbnail.classList.add('co-active');
    collections.forEach(function(collection) {
      collection.classList.remove('co-active');
      collection.classList.add('co-hidden');
    });
    const collectionId = thumbnail.getAttribute('data-collection-id');
    const selectedCollection = document.getElementById(collectionId);
    selectedCollection.classList.remove('co-hidden');
    selectedCollection.classList.add('co-active');
  });
});
// =============== =============== =============== =============== =============== =============== RECIPES SECTION
(function() {
  'use strict';
  
  function setEqualHeights() {
    const titleElements = document.querySelectorAll('.co-p-recipes-article-title');
    
    if (titleElements.length === 0) return;
    
    titleElements.forEach(el => el.style.height = 'auto');
    
    let maxHeight = 0;
    titleElements.forEach(el => {
      const height = el.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    
    titleElements.forEach(el => {
      el.style.height = maxHeight + 'px';
    });
  }

  const flkty = new Flickity('.co-p-recipes-slider', {
    pageDots: false, 
    draggable: true,
    prevNextButtons: false,
    cellAlign: "center",
    contain: true,
    on: {
      ready: function() {
        setEqualHeights();
      },
      settle: function() {
        setEqualHeights();
      }
    }
  });
  
  window.addEventListener('resize', function() {
    flkty.resize();
    setEqualHeights();
  });
})();
